import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import Header from '../components/Header';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div style={{ backgroundColor: '#FDFBF7', minHeight: '100vh' }}>
      <Header />
      <div className="max-w-2xl mx-auto px-6 py-24 text-center">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-8" style={{ backgroundColor: '#FEE2E2' }}>
          <XCircle className="w-12 h-12" style={{ color: '#DC2626', strokeWidth: 2 }} />
        </div>
        <h1 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Merriweather, serif', color: '#2C2A29' }}>Payment Cancelled</h1>
        <p className="text-lg mb-8" style={{ fontFamily: 'Nunito, sans-serif', color: '#595553' }}>
          Your payment was cancelled. No charges were made. You can try again whenever you're ready.
        </p>
        <button
          onClick={() => navigate('/consultations')}
          className="inline-flex items-center gap-2 px-8 py-4 rounded-full transition-all duration-300 hover:-translate-y-1"
          style={{ fontFamily: 'Nunito, sans-serif', backgroundColor: '#E57A44', color: '#FDFBF7', fontWeight: 600 }}
          data-testid="back-to-consultations"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>Back to Consultations</span>
        </button>
      </div>
    </div>
  );
}
